import React from "react";
import { LogoDark } from "@/components/Logo";
import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const startAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy-deep text-offwhite flex flex-col relative">
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
      <header className="relative max-w-7xl w-full mx-auto px-6 sm:px-10 py-8">
        <a href="/" className="inline-block" data-testid="login-home-link"><LogoDark /></a>
      </header>
      <main className="relative flex-1 flex items-center">
        <div className="max-w-7xl w-full mx-auto px-6 sm:px-10 grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="text-[11px] uppercase tracking-[0.35em] text-gold-bright mb-6">— Operator Console</div>
            <h1 className="font-display text-5xl sm:text-6xl leading-[0.95]">
              Sign in to the <em className="text-gold-bright not-italic">LocalRida</em> control room.
            </h1>
            <p className="mt-6 text-offwhite/70 leading-relaxed max-w-lg">
              This console routes live inbound leads to whichever operator is currently on duty.
              Access is restricted to the LocalRida operations lead.
            </p>
          </div>
          <div className="border border-navy-soft bg-navy p-10">
            <div className="text-[10px] uppercase tracking-[0.28em] text-gold-bright mb-3">Restricted Access</div>
            <div className="font-display text-3xl mb-8">Google sign-in</div>
            <button
              onClick={startAuth}
              data-testid="login-google-button"
              className="w-full inline-flex items-center justify-center gap-3 bg-gold-bright text-navy-deep px-6 py-4 text-xs uppercase tracking-[0.28em] hover:bg-gold transition-colors"
            >
              <GoogleLogo size={20} weight="bold" />
              Continue with Google
            </button>
            <p className="mt-6 text-offwhite/50 text-xs leading-relaxed">
              Only pre-authorized Google accounts can access the admin dashboard. Unauthorized sign-ins are rejected server-side.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
